//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React, { useEffect, useState, useRef } from 'react';
import { useNav } from '../../hooks/nav';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import { colors } from 'src/styles/colors';
import Analytics from '@web-solutions/module-analytics';
import './style.scss';
import { ReactComponent as ActiveSVG } from '../../assets/images/CheckWhite.svg';
import getLocale from 'src/localization/get-locale';

const DynamicAnalyzingPage = ({ pageConfig, onNext }) => {
  const [percentage, setPercentage] = useState(0);
  const [activeBar, setActiveBar] = useState(0);
  const locale = getLocale();

  const animationRef = useRef({
    hasCompleted: false,
    animationId: null,
  });
  const startTimeRef = useRef(performance.now());

  const { currentIndex } = useNav();

  useEffect(() => {
    const duration = pageConfig.options.length > 0 ? 10000 : 3000;

    const animate = (time) => {
      const progress = Math.min((time - startTimeRef.current) / duration, 1);
      const newPercentage = Math.round(progress * 100);
      setPercentage(newPercentage);

      if (newPercentage < 25) {
        setActiveBar(0);
      } else if (newPercentage >= 25 && newPercentage < 50) {
        setActiveBar(1);
      } else if (newPercentage >= 50 && newPercentage < 75) {
        setActiveBar(2);
      } else if (newPercentage >= 75) {
        setActiveBar(3);
      }

      if (newPercentage >= 100 && !animationRef.current.hasCompleted) {
        animationRef.current.hasCompleted = true;
        cancelAnimationFrame(animationRef.current.animationId);
        Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
          page: pageConfig.id,
        });
        onNext();
        return;
      }

      if (progress < 1) {
        animationRef.current.animationId = requestAnimationFrame(animate);
      }
    };

    animationRef.current.hasCompleted = false;
    animationRef.current.animationId = requestAnimationFrame(animate);

    return () => {
      if (animationRef.current.animationId) {
        cancelAnimationFrame(animationRef.current.animationId);
      }
    };
  }, [onNext, pageConfig.id, currentIndex]);

  return (
    <div className='layout analyzing-page'>
      <div style={{ marginTop: '40px', marginBottom: '8px' }}>
        <div style={{ position: 'relative', width: 145, height: 145, margin: '0 auto' }}>
          <CircularProgressbar
            value={percentage}
            styles={buildStyles({
              pathColor: 'rgb(0, 206, 0)',
              trailColor: colors.baseWhite,
              strokeLinecap: 'round',
            })}
            text={''}
          />
          <div
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              fontSize: 40,
              lineHeight: '40px',
              letterSpacing: '-0.032px',
              fontWeight: 700,
              fontFamily: 'Inter',
            }}
          >
            {percentage}%
          </div>
        </div>
      </div>

      <Title tag='h2'>{pageConfig.title[locale]}</Title>

      {pageConfig.options && (
        <div className='content' style={{ marginTop: '40px' }}>
          <div className='analysis'>
            {pageConfig.options.map((option, index) => (
              <Progress
                key={option.id}
                value={option.text}
                label={option.text[locale]}
                percentage={percentage}
                index={index}
                activeBar={activeBar}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default DynamicAnalyzingPage;

const Progress = ({ label, percentage, index, activeBar }) => {
  const position = index - activeBar;

  let blurClass = '';
  if (position === 1) blurClass = 'blur-4';
  else if (position > 1) blurClass = 'blur-8';

  const isHidden = position < 0;

  const segmentStart = index * 25;
  const segmentEnd = segmentStart + 25;

  let localPercentage = 0;
  if (percentage >= segmentEnd) {
    localPercentage = 100;
  } else if (percentage >= segmentStart) {
    localPercentage = ((percentage - segmentStart) / 25) * 100;
  }

  const isActive = percentage >= segmentStart && percentage < segmentEnd;
  const isCompleted = percentage >= segmentEnd;

  const shiftClass = isCompleted ? 'shifted' : '';

  return (
    <div
      className={`progress 
             ${isCompleted ? 'completed' : ''} 
             ${isActive ? 'active' : ''} 
             ${blurClass} 
             ${isHidden ? 'hide' : ''} 
             ${shiftClass}`}
    >
      <div className={'progress-bar'}>
        <div className='progress-fill' style={{ width: `${localPercentage}%` }}></div>
        <div className='header'>
          <span>{label}</span>
          {isCompleted && <ActiveSVG />}
        </div>
      </div>
    </div>
  );
};
